const resultState = (state) => {
  switch (state) {
    case 'X':
      state = 'Programable';
      break;
    case 'P':
      state = 'Programado';
      break;
    case 'G':
      state = 'Facturado SAP';
      break;
    case 'W':
      state = 'Reparto';
      break;
    case 'S':
      state = 'Sin stock';
      break;
    case 'R':
      state = 'Reparto';
      break;
    case 'F':
      state = 'Finalizado';
      break;
    case 'D':
      state = 'Borrador';
      break;
    case 'A':
      state = 'Anulado';
      break;
    default:
      state = 'Otros';
      break;
  }
  return state;
};
export default resultState;
